import { Link } from "react-router-dom";

export const LegalPage = ({ pageTestId, title, updated, sections }) => (
    <div className="min-h-screen bg-obsidian text-white" data-testid={pageTestId}>
        <header className="border-b border-white/10">
            <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
                <Link to="/" className="font-display font-bold uppercase tracking-tight text-lg" data-testid="legal-home-link">
                    SPCLIVE<span className="text-blaze">//</span>STUDIO
                </Link>
                <div className="flex gap-5 font-mono text-[10px] uppercase tracking-[0.2em]">
                    <Link to="/terms" className="text-white/50 hover:text-blaze transition-colors" data-testid="legal-terms-link">Terms</Link>
                    <Link to="/privacy" className="text-white/50 hover:text-blaze transition-colors" data-testid="legal-privacy-link">Privacy</Link>
                </div>
            </div>
        </header>
        <main className="max-w-4xl mx-auto px-6 py-14">
            <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-blaze">/ Legal</div>
            <h1 className="font-display font-bold uppercase text-3xl sm:text-4xl mt-2 tracking-tight">{title}</h1>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/30 mt-3 mb-10">
                Last updated: {updated}
            </p>
            <div className="space-y-10">
                {sections.map((s, i) => (
                    <section key={s.heading}>
                        <h2 className="font-display font-bold uppercase text-lg tracking-tight text-white mb-3">
                            {i + 1}. {s.heading}
                        </h2>
                        {s.paragraphs.map((p) => (
                            <p key={p.slice(0, 60)} className="text-sm text-white/60 leading-relaxed mb-3">{p}</p>
                        ))}
                        {s.bullets && (
                            <ul className="list-disc pl-5 space-y-1.5 text-sm text-white/60 leading-relaxed">
                                {s.bullets.map((b) => (
                                    <li key={b.slice(0, 60)}>{b}</li>
                                ))}
                            </ul>
                        )}
                    </section>
                ))}
            </div>
            <div className="mt-14 border-t border-white/10 pt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-white/30">
                Questions? Open a ticket from your console Support page.
            </div>
        </main>
    </div>
);
